import services from '@/http'
import * as storage from '../storage'
import * as types from './mutation-types'

export const ActionDoLogin = ({
  dispatch,
  state
}, payload) => {

  if (state.isMember)
    return services.auth.loginMember(payload).then(res => {
      dispatch('ActionSetUser', res.data.user)
      dispatch('ActionSetToken', res.data.token)
      //dispatch('ActionSetIsMember', isMember)

      console.log('LOGIN MEMBER state.isMember ? ', state.isMember)
    })
  else
    return services.auth.login(payload).then(res => {
      dispatch('ActionSetUser', res.data.user)
      dispatch('ActionSetToken', res.data.token)
      //dispatch('ActionSetIsMember', isMember)

      console.log('LOGIN Manager state.isMember ? ', state.isMember)
    })
}

export const ActionCheckToken = ({
  dispatch,
  state
}) => {
  if (state.token) {
    return Promise.resolve(state.token)
  }

  const token = storage.getLocalToken()

  if (!token) {
    return Promise.reject(new Error('Token Inválido'))
  }

  dispatch('ActionSetToken', token);
  dispatch('ActionCheckIsMember');

  return dispatch('ActionLoadSession');
}

export const ActionLoadSession = ({
  dispatch,
  state
}) => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        const {
          data: {
            user
          }
        } = state.isMember ? await services.auth.loadSessionMember() : await services.auth.loadSession()

        dispatch('ActionSetUser', user)
        resolve()
      } catch (err) {
        dispatch('ActionSignOut')
        reject(err)
      }

    })()
  });
}

export const ActionSetUser = ({
  commit
}, payload) => {
  commit(types.SET_USER, payload)
}

export const ActionSetToken = ({
  commit
}, payload) => {
  storage.setLocalToken(payload)
  storage.setHeaderToken(payload)
  commit(types.SET_TOKEN, payload)
}


export const ActionSignOut = ({
  dispatch
}) => {
  storage.setHeaderToken('')
  storage.deleteLocalToken()
  dispatch('ActionSetUser', {})
  dispatch('ActionSetToken', '')
}

export const ActionSetIsMember = ({
  commit
}, payload) => {
  console.log('ActionSetIsMember payload', payload)

  if (payload === undefined) return;

  storage.setLocalIsMember(payload)
  commit(types.SET_IS_MEMBER, payload)
}

export const ActionCheckIsMember = ({
  dispatch,
  state
}) => {

  try {
    const isMember = storage.getLocalIsMember()

    if (isMember == null)
      dispatch('ActionSetIsMember', true)
    else if (isMember == 'true')
      dispatch('ActionSetIsMember', true)
    else if (isMember == 'false')
      dispatch('ActionSetIsMember', false)
    else
      dispatch('ActionSetIsMember', true)

  } catch (error) {
    dispatch('ActionSetIsMember', true)

  }
  console.log('ActionCheckIsMember: state.isMember? ', state.isMember)
  return state.isMember;
}